//*************************************************************************************
//* WaMS Custom Validators
//* Version 1.0
//* Author: Damian Koch
//* JavaScript component of custom ComponentModel.DataAnnotations.ValidationAttribute
//* Adds client-side support of RequiredIf, and ValidYearDuration
//* Requires jQuery, jQuery.validate, jQuery.validate.unobtrusive
//*************************************************************************************

//07/06/2018    Simons      [STUDYAB-106]: Extended the jquery range validator to work for required checkboxes
//11/05/2018    Kraus       [STUDYAB-1078]: Added AtLeastOneRequired validation.
//12/5/18       Huisenga    [STUDYAB-1091]: Fixed required if

jQuery(function () {
    jQuery.validator.addMethod('validyearduration', function (value, element, params) {
        if (value < 0) {
            return false;
        }
        return true;
    }, '');

    jQuery.validator.unobtrusive.adapters.add('validyearduration', function (options) {
        options.rules['validyearduration'] = {};
        options.messages['validyearduration'] = options.message;
    });

    jQuery.validator.addMethod('requiredif', function (value, element, parameters) {
        var name = '[name="' + parameters['dependentproperty'] + '"]';
        // get the target value (as a string, as that's what actual value will be)
        var targetValue = parameters['targetvalue'];
        targetValue = (targetValue === null ? '' : targetValue).toString();

        // get the actual value of the target control note - this probably needs to cater for more control types, e.g. radios
        var control = $(name, element.closest('form'));

        var controlType = control.attr('type');
		var actualValue = controlType === 'checkbox' ? control.attr('checked').toString() : (control.length > 1 && $(control[0]).attr('type') === 'radio' ? $(name + ":checked", element.closest('form')).val() : control.val());
		actualValue = ((actualValue === null || actualValue == undefined) ? '' : actualValue).toString();
        // if the condition is true, reuse the existing  required field validator functionality
        if (targetValue.toLowerCase() === actualValue.toLowerCase()) {
            return $.validator.methods.required.call(this, value, element, parameters);
        }
        return true;
    });

    jQuery.validator.unobtrusive.adapters.add('requiredif', ['dependentproperty', 'targetvalue'], function (options) {
        options.rules['requiredif'] = { dependentproperty: options.params['dependentproperty'], targetvalue: options.params['targetvalue'] };
        options.messages['requiredif'] = options.message;
    });

    jQuery.validator.addMethod('requiredifdifferent', function (value, element, parameters) {
        var nameA = '[name="' + parameters['comparepropertya'] + '"]';
        var nameB = '[name="' + parameters['comparepropertyb'] + '"]';

        // get the actual value of the target controls - note - this probably needs to cater for more control types, e.g. radios
        var controlA = $(nameA, element.closest('form'));
        var controlB = $(nameB, element.closest('form'));

        //Assumption is that they are the same type of control
        var controlTypeA = controlA.attr('type');
        var controlTypeB = controlB.attr('type');

        var valA = '';
        if (controlTypeA === 'checkbox') {
            valA = controlA.attr('checked').toString();
        }
        else if (controlA.length > 1 && $(controlA[0]).attr('type') === 'radio') {
            valA = $(nameA + ":checked", element.closest('form')).val();
        }
        else {
            valA = controlA.val();
        }

        var valueB = '';
        if (controlTypeB === 'checkbox') {
            valueB = controlB.attr('checked').toString();
        }
        else if (controlB.length > 1 && $(controlB[0]).attr('type') === 'radio') {
            valueB = $(nameB + ":checked", element.closest('form')).val();
        }
        else {
            valueB = controlB.val();
        }
        
        valA = (valA === null ? '' : valA).toString();
        valueB = (valueB === null ? '' : valueB).toString();
        // if the condition is true, reuse the existing  required field validator functionality
        if (valA.toLowerCase() !== valueB.toLowerCase()) {
            return $.validator.methods.required.call(this, value, element, parameters);
        }
        return true;
    });

    jQuery.validator.unobtrusive.adapters.add('requiredifdifferent', ['comparepropertya', 'comparepropertyb'], function (options) {
        options.rules['requiredifdifferent'] = { comparepropertya: options.params['comparepropertya'], comparepropertyb: options.params['comparepropertyb'] };
        options.messages['requiredifdifferent'] = options.message;
    });

    jQuery.validator.addMethod('requiredtrue', function (value, element, params) {
        return value === true || value === 'true';
    }, '');

    jQuery.validator.unobtrusive.adapters.add('requiredtrue', function (options) {
        options.rules['requiredtrue'] = {};
        options.messages['requiredtrue'] = options.message;
    });

    jQuery.validator.addMethod('requiredatleastone', function (value, element, parameters) {
        //get the name of the list of elements, i.e. left of []
        var listName = element.name.substring(0, element.name.indexOf('[', 0));
        var name = '[name^="' + listName + '"]:checked';
        var controls = $(name, element.closest('form'));
        return controls.length > 0;
    });

    jQuery.validator.unobtrusive.adapters.add('requiredatleastone', function (options) {
        options.rules['requiredatleastone'] = {};
        options.messages['requiredatleastone'] = options.message;
    });

    jQuery.validator.addMethod('requirednotnull', function (value, element, params) {
        return !(value === null);
    }, '');

    jQuery.validator.addMethod('requirednotnull', function (value, element, parameters) {

        var noParams = true;

        if (typeof parameters['dependentproperty'] !== 'undefined') {
            noParams = parameters['dependentproperty'] === '';
        }

        if (noParams) {
            return value !== null;
        } else {
            var name = "[name='" + parameters['dependentproperty'] + "']";
            var control = $(name, element.closest('form'));
            var controltype = control.attr('type');

            var actualvalue = '';
            if (controltype === 'checkbox') {
                if (control.is(':checked')) {
                    actualvalue = 'True';
                } else {
                    actualvalue = 'False';
                }
            }
            else if (control.length > 1 && $(control[0]).attr('type') === 'radio') {
                return $(name + ":checked", element.closest('form')).length === 1;
            }
            else {
                actualvalue = control.val();
            }

            if (actualvalue === '') {
                return value === null;
            }
        }
        return true;
    });
    //}, "");

    jQuery.validator.unobtrusive.adapters.add('requirednotnull', ['dependentproperty'], function (options) {
        options.rules['requirednotnull'] = { dependentproperty: options.params['dependentproperty'] };
        options.messages['requirednotnull'] = options.message;
    });



    // extend jquery range validator to work for required checkboxes
    var defaultRangeValidator = $.validator.methods.range;
    $.validator.methods.range = function (value, element, param) {
        if (element.type === 'checkbox') {
            // if it's a checkbox return true if it is checked
            return element.checked;
        } else {
            // otherwise run the default validation function
            return defaultRangeValidator.call(this, value, element, param);
        }
    };
}(jQuery));